/* SPEC-509 — a walk-through's B mark (data: tourGlyphData.ts). Decorative: the tour title
 * beside it is the accessible name. */
import { MarkSvg } from '../../brand/marks/Mark';
import { TOUR_GLYPHS, type TourGlyphId } from './tourGlyphData';

export type { TourGlyphId };

export function TourGlyph({ id, size = 20 }: { id: TourGlyphId; size?: number }) {
  return <MarkSvg drawing={TOUR_GLYPHS[id]} size={size} />;
}
